import { render, staticRenderFns } from "./hero-cmp.vue?vue&type=template&id=48075630&scoped=true"
import script from "./hero-cmp.vue?vue&type=script&lang=js"
export * from "./hero-cmp.vue?vue&type=script&lang=js"
import style0 from "./hero-cmp.vue?vue&type=style&index=0&id=48075630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48075630",
  null
  
)

export default component.exports